export default __webpack_public_path__ + "static/media/AND-400.bc59af0e.jpg";